/* eslint-disable react/no-array-index-key */
import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";

import TablePagination from "@mui/material/TablePagination";

const headRows = translate => [
  { id: "changeBy", label: translate.changedBy },
  { id: "changeDate", label: translate.changeDate },
  { id: "newValue", label: translate.newValue },
  { id: "oldValue", label: translate.oldValue },
  { id: "param", label: translate.changedValue },
];

const labelSx = {
  fontWeight: "bold",
  minWidth: 150,
  maxWidth: 150,
};

const cellSx = {
  minWidth: 200,
  maxWidth: 200,
};

const PM_INTERNAL_ROWS_OPTIONS = [5, 10, 25, 50];

function normalizePMInternalRowsPerPage(raw) {
  const n = Number(raw);
  return PM_INTERNAL_ROWS_OPTIONS.includes(n) ? n : 10;
}

const PMInternalInfo = ({ conference, translate }) => {
  const [rowsPerPage, setRowsPerPage] = useState(() => normalizePMInternalRowsPerPage(10));
  const [page, setPage] = useState(0);

  /** Copy so we never mutate `conference.changeLog`; deps only re-run when the prop reference changes (no setState loop on fresh `[]`). */
  const rows = useMemo(() => [...(conference.changeLog ?? [])], [conference.changeLog]);

  const handleChangePage = newPage => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(normalizePMInternalRowsPerPage(+event.target.value));
  };

  return rows ? (
    <Paper sx={{ p: 2 }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            {headRows(translate).map(cell => (
              <TableCell key={cell.label}>
                <Box sx={labelSx}>{cell.label}</Box>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows
            .map((row, index) => (
              <TableRow sx={cellSx} key={"rows" + index}>
                {headRows(translate).map((cell, cellIndex) => (
                  <TableCell key={"cells" + cellIndex} sx={cellSx}>
                    {cell.id === "param" ? translate[row[cell.id]] : row[cell.id]}
                  </TableCell>
                ))}
              </TableRow>
            ))
            .reverse()
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={PM_INTERNAL_ROWS_OPTIONS}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        slotProps={{
          actions: {
            previousButton: {
              "aria-label": "Previous Page",
            },
            nextButton: {
              "aria-label": "Next Page",
            },
          },
        }}
        onPageChange={(event, newPage) => handleChangePage(newPage)}
        onRowsPerPageChange={event => handleChangeRowsPerPage(event)}
      />
    </Paper>
  ) : null;
};

PMInternalInfo.propTypes = {
  conference: PropTypes.object.isRequired,
  translate: PropTypes.object.isRequired,
};

export default PMInternalInfo;
